import './style.css';
import { classifyCaptureError, createAudioContext, startCapture, stopCapture, type Capture } from './audio/capture';
import { mountDiagnostics, type DiagnosticsPanel } from './ui/diagnostics';
import { renderScreen, type ScreenState } from './ui/screen';
import { createOdfNode, type OdfNode } from './audio/odf-node';

const root = document.getElementById('app')!;
let capture: Capture | null = null;
let panel: DiagnosticsPanel | null = null;
let odfNode: OdfNode | null = null;

function show(state: ScreenState): void {
  renderScreen(root, state, { onStart: () => void start(), onStop: stop });
}

async function start(): Promise<void> {
  // Kontext musí vzniknout synchronně v obsluze klepnutí (spec 7.1).
  const context = createAudioContext();
  show({ kind: 'requesting' });
  try {
    capture = await startCapture(context);
    odfNode = await createOdfNode(context, capture.source, 'full');
    show({ kind: 'running' });
    panel = mountDiagnostics(root.querySelector('#diagnostics')!, capture);
    odfNode.onMessage((m) => {
      if (m.type === 'odf') panel?.pushOdf(m.values);
      else if (m.type === 'level') panel?.pushLevel(m.rms);
    });
  } catch (err) {
    console.error(err);
    if (capture) {
      stopCapture(capture);
      capture = null;
    } else {
      await context.close();
    }
    show({ kind: 'failed', error: classifyCaptureError(err) });
  }
}

function stop(): void {
  panel?.destroy();
  panel = null;
  odfNode?.destroy();
  odfNode = null;
  if (capture) stopCapture(capture);
  capture = null;
  show({ kind: 'idle' });
}

show({ kind: 'idle' });
